// extracted by mini-css-extract-plugin
export default {"buttons":"AboutButtons_buttons__ELqD1","btn":"AboutButtons_btn__oXb2l","btn_active":"AboutButtons_btn_active__NQ+ui"};